import {
    CognitoUserPool,
  } from "amazon-cognito-identity-js";

var poolData = {
  UserPoolId: "us-east-1_DRs6LjDMd",
  ClientId: "45ga8lutci55nap3smmspc9lr7",
};
export const userPool = new CognitoUserPool(poolData);